/**
 * reCAPTCHA v3 Auto-Initializing Utility
 *
 * Usage: Add these attributes to your form:
 *   - data-recaptcha-sitekey="{{ config('services.recaptcha.sitekey') }}"
 *   - data-recaptcha-action="contact" (optional, defaults to "submit")
 *
 * Add hidden input inside form:
 *   - <input type="hidden" name="recaptcha" data-recaptcha-token>
 *
 * Load scripts in blade:
 *   @push("scripts")
 *       <script src="https://www.google.com/recaptcha/api.js?render={{ config('services.recaptcha.sitekey') }}"></script>
 *       <script src="{{ mix('js/recaptcha.js') }}" defer></script>
 *   @endpush
 */

(function () {
    "use strict";

    /**
     * Initialize reCAPTCHA on all forms with data-recaptcha-sitekey
     */
    function init() {
        const forms = document.querySelectorAll("form[data-recaptcha-sitekey]");

        forms.forEach((form) => {
            const siteKey = form.dataset.recaptchaSitekey;
            const action = form.dataset.recaptchaAction || "submit";
            const tokenInput = form.querySelector("[data-recaptcha-token]");

            if (!siteKey || !tokenInput) {
                console.warn("reCAPTCHA: Missing sitekey or token input", form);
                return;
            }

            form.addEventListener("submit", async function (e) {
                e.preventDefault();

                // Prevent double submission
                if (form.dataset.recaptchaSubmitting === "true") return;
                form.dataset.recaptchaSubmitting = "true";

                // Get submit button and show loading
                const submitBtn = form.querySelector('[type="submit"]');
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.classList.add("btn-loading");
                }

                try {
                    const token = await getToken(siteKey, action);

                    if (token) {
                        tokenInput.value = token;
                        form.submit();
                    } else {
                        showError(form, "Verification failed. Please try again.");
                        resetForm(form, submitBtn);
                    }
                } catch (error) {
                    console.error("reCAPTCHA error:", error);
                    showError(form, "An error occurred. Please try again.");
                    resetForm(form, submitBtn);
                }
            });
        });
    }

    /**
     * Get reCAPTCHA token
     */
    async function getToken(siteKey, action) {
        if (typeof grecaptcha === "undefined") {
            console.warn("reCAPTCHA: grecaptcha not loaded");
            return null;
        }

        return new Promise((resolve) => {
            grecaptcha.ready(async () => {
                try {
                    const token = await grecaptcha.execute(siteKey, { action });
                    resolve(token);
                } catch (error) {
                    console.error("reCAPTCHA execute error:", error);
                    resolve(null);
                }
            });
        });
    }

    /**
     * Show error message
     */
    function showError(form, message) {
        let errorEl = form.querySelector(".recaptcha-error");

        if (!errorEl) {
            errorEl = document.createElement("div");
            errorEl.className = "recaptcha-error form-text text-danger mb-3";
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn && submitBtn.parentNode) {
                submitBtn.parentNode.insertBefore(errorEl, submitBtn);
            } else {
                form.appendChild(errorEl);
            }
        }

        errorEl.innerHTML = '<i class="fas fa-exclamation-triangle me-2"></i>' + message;

        setTimeout(() => errorEl.remove(), 5000);
    }

    /**
     * Reset form state
     */
    function resetForm(form, submitBtn) {
        form.dataset.recaptchaSubmitting = "false";
        if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove("btn-loading");
        }
    }

    // Auto-initialize when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
